import { useEffect, useRef, useState } from "react";
import classes from "./Counter.module.css";

function useCountUp(target, active) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!active) return;

    const duration = 1200;
    const startTime = performance.now();
    let animationFrame;

    const update = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);

      const easedProgress = 1 - Math.pow(1 - progress, 3);

      setCount(Math.round(target * easedProgress));

      if (progress < 1) {
        animationFrame = requestAnimationFrame(update);
      }
    };

    animationFrame = requestAnimationFrame(update);

    return () => cancelAnimationFrame(animationFrame);
  }, [active, target]);

  return count;
}

function CounterItem({ item, active }) {
  const count = useCountUp(item.value, active);

  return (
    <div className={classes.item}>
      <span className={classes.value}>
        {count}
        {item.suffix || ""}
      </span>

      <span className={classes.label}>{item.label}</span>
    </div>
  );
}

export default function Counter({ data = [] }) {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = sectionRef.current;

    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.3,
      },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  if (!data.length) return null;

  return (
    <section ref={sectionRef} className={classes.section}>
      <div className={classes.shell}>
        <div className={classes.grid}>
          {data.map((item) => (
            <CounterItem
              key={item.id || item.label}
              item={item}
              active={isVisible}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
